import React, { useContext } from 'react';
import UserContext from 'contexts/UserContext';

import { Column } from 'components/Layouts/Flow';
import { Avatar, Input, Select } from 'components/Form';

import { USER_ROLES, USER_STATES, USER_GENDERS } from 'utils/Constants';

const General = () => {
	// Use user's context
	const { user, errors, handleUser } = useContext(UserContext);

	// Handles input's onChange event
	// @event: object | native onChange event
	const onChange = event => {
		const { name, value } = event.target || event;
		handleUser({
			type: name === 'role' ? 'ON_CHANGE_ROLE' : 'ON_CHANGE',
			payload: { name, value }
		});
	};

	return (
		<>
			<Column size="12">
				<h2>Pamatinformācija</h2>
			</Column>

			<Column size="12">
				<Avatar
					name="avatar"
					value={user.avatar}
					error={errors.avatar}
					onChange={onChange}
				/>
			</Column>

			<Column size="6">
				<Input
					type="text"
					name="name"
					label="Vārds"
					value={user.name}
					error={errors.name}
					onChange={onChange}
				/>
			</Column>

			<Column size="6">
				<Input
					type="text"
					name="surname"
					label="Uzvārds"
					value={user.surname}
					error={errors.surname}
					onChange={onChange}
				/>
			</Column>

			<Column size="6">
				<Input
					type="text"
					name="personalCode"
					label="Personas kods"
					value={user.personalCode}
					error={errors.personalCode}
					onChange={onChange}
				/>
			</Column>

			<Column size="6">
				<Select
					name="gender"
					label="Dzimums"
					value={user.gender}
					error={errors.gender}
					options={USER_GENDERS}
					onChange={onChange}
				/>
			</Column>

			<Column size="12" className="withMarginTop">
				<h2>Kontaktinformācija</h2>
			</Column>

			<Column size="6">
				<Input
					type="email"
					name="email"
					label="E-pasts"
					value={user.email}
					error={errors.email}
					onChange={onChange}
				/>
			</Column>

			<Column size="6">
				<Input
					type="text"
					name="phoneNumber"
					label="Telefona numurs"
					value={user.phoneNumber}
					error={errors.phoneNumber}
					onChange={onChange}
				/>
			</Column>

			<Column size="12" className="withMarginTop">
				<h2>Autorizācija</h2>
			</Column>

			<Column size="6">
				<Select
					name="role"
					label="Grupa"
					value={user.role}
					error={errors.role}
					options={USER_ROLES}
					onChange={onChange}
				/>
			</Column>

			<Column size="6">
				<Select
					name="status"
					label="Statuss"
					value={user.status}
					error={errors.status}
					options={USER_STATES}
					onChange={onChange}
				/>
			</Column>

			{/* <Column size="12">
				<Tags
					name="tags"
					label="Birkas"
					tags={user.tags}
					onChange={onChange}
				/>
			</Column> */}
		</>
	);
};

export default General;
